import $ from '@rover/globals/jquery';

function init() {
  if ($.isFunction($.fancybox)) {
    $(document).on('click', '.fancybox-close', $.fancybox.close);
  }
}

export default {
  init,
};



// WEBPACK FOOTER //
// ../utilities/fancybox.js